import { z } from 'zod';
import { createNumericKeyRecordSchema } from '../KeyRecordSchemas.ts';
import { createPartialStrictObjectSchemaWithAtLeastOneProperty } from '../PartialStrictObjectSchema.ts';
import { validateState } from '../ValidateState.ts';
import { PlayerColor } from '../PlayerState.ts';
// CornerVariables: https://prntscr.com/w5qvpk
export var TileCornerDirection = /*#__PURE__*/ function(TileCornerDirection) {
    TileCornerDirection[TileCornerDirection["North"] = 0] = "North";
    TileCornerDirection[TileCornerDirection["South"] = 1] = "South";
    return TileCornerDirection;
}({});
export var TileCornerBuildingType = /*#__PURE__*/ function(TileCornerBuildingType) {
    TileCornerBuildingType[TileCornerBuildingType["Settlement"] = 1] = "Settlement";
    TileCornerBuildingType[TileCornerBuildingType["City"] = 2] = "City";
    TileCornerBuildingType[TileCornerBuildingType["DestroyedCity"] = 3] = "DestroyedCity";
    TileCornerBuildingType[TileCornerBuildingType["KnightActiveLevel1"] = 4] = "KnightActiveLevel1";
    TileCornerBuildingType[TileCornerBuildingType["KnightActiveLevel2"] = 5] = "KnightActiveLevel2";
    TileCornerBuildingType[TileCornerBuildingType["KnightActiveLevel3"] = 6] = "KnightActiveLevel3";
    TileCornerBuildingType[TileCornerBuildingType["KnightInactiveLevel1"] = 7] = "KnightInactiveLevel1";
    TileCornerBuildingType[TileCornerBuildingType["KnightInactiveLevel2"] = 8] = "KnightInactiveLevel2";
    TileCornerBuildingType[TileCornerBuildingType["KnightInactiveLevel3"] = 9] = "KnightInactiveLevel3";
    return TileCornerBuildingType;
}({});
export var TileCornerBonusType = /*#__PURE__*/ function(TileCornerBonusType) {
    TileCornerBonusType[TileCornerBonusType["IslandSettlingChits"] = 0] = "IslandSettlingChits";
    TileCornerBonusType[TileCornerBonusType["CityWall"] = 1] = "CityWall";
    TileCornerBonusType[TileCornerBonusType["MetropolisScience"] = 2] = "MetropolisScience";
    TileCornerBonusType[TileCornerBonusType["MetropolisTrade"] = 3] = "MetropolisTrade";
    TileCornerBonusType[TileCornerBonusType["MetropolisPolitics"] = 4] = "MetropolisPolitics";
    return TileCornerBonusType;
}({});
export const tileCornerStateSchema = z.object({
    x: z.number().int().readonly(),
    y: z.number().int().readonly(),
    z: z.enum(TileCornerDirection).readonly(),
    owner: z.union([
        z.enum(PlayerColor).exclude([
            'None'
        ]),
        z.null()
    ]).exactOptional(),
    buildingType: z.union([
        z.enum(TileCornerBuildingType),
        z.null()
    ]).exactOptional(),
    bonuses: z.array(z.enum(TileCornerBonusType)).exactOptional(),
    restrictedStartingPlacement: z.literal(true).exactOptional()
}).strict();
export function validateTileCornerState(data) {
    return validateState(tileCornerStateSchema, data);
}
export const tileCornerStatesSchema = createNumericKeyRecordSchema(tileCornerStateSchema);
export function validateTileCornerStates(data) {
    return validateState(tileCornerStatesSchema, data);
}
export const tileCornerStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(tileCornerStateSchema);
export const tileCornerStatesPartialSchema = createNumericKeyRecordSchema(tileCornerStatePartialSchema, {
    requireAtLeastOneEntry: true
});
